var products = [];
var variants = [];

if (localStorage.getItem("cookieAccepted") != "true") {
  setTimeout(() => {
    setPopup(6);
    localStorage.setItem("cookieAccepted", true);
  }, 1000);
}

window.addEventListener("load", async function () {
  if (
    document.location.href.includes("wishlist") &&
    !document.location.href.includes("wishlist-gift") &&
    !document.location.href.includes("wishlist-search")
  ) {
    await getItem();

    const data = {
      email: document.getElementById("wishlist-item-email").textContent,
    };

    await fetch(
      "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/getUserByEmail",
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(data),
      }
    ).then(async (response) => {
      const res = await response.json();
      const users = res.user;
      console.log(users);
      if (users.length == 0) {
        document.getElementById("user-type").checked = true;
      } else {
        document.getElementById("user-type").checked =
          users[0].type == 1 ? true : false;
      }
    });

    const url = new URL(window.location.href);
    const email = url.searchParams.get("k");

    if (email) {
      const data = {
        email: email,
      };
      const response = await fetch(
        "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/getWishlists",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      const res = await response.json();
      products = res.wishlists;
      variants = res.variants;

      if (res.status == "no user") {
        products = [];
      }
      await drawWishLists();
    }
  }

  // if (document.location.href.includes("/account")) {
  //   const data = {
  //     email: document.getElementById("wishlist-item-email").textContent
  //   }

  //   await fetch('https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/getUserByEmail', {
  //     method: 'POST',
  //     headers: { "content-type": "application/json" },
  //     body: JSON.stringify(data),
  //   }).then(async (response) => {
  //     const res = await response.json();
  //     const users = res.user;
  //     console.log(users);
  //     if (users.length == 0) {
  //       document.getElementById("user-type").checked = true;
  //     } else {
  //       document.getElementById("user-type").checked = users[0].type == 1 ? true : false;
  //     }
  //   });
  // }

  if (document.location.href.includes("wishlist-gift")) {
    document.getElementById("shopify-section-header").style.display = "none";
    document.getElementById("shopify-section-footer").style.display = "none";
    document.getElementById("gift-sticky").style.display = "none";
  }

  if (
    (document.referrer == "https://pandora-eshop.jo/account/register" ||
      document.referrer == "https://pandora-eshop.jo/challenge") &&
    document.location.href == "https://pandora-eshop.jo/"
  ) {
    await updateCustomerAddress();
  }
});

let searchMsgStatus = 0;
async function drawWishLists() {
  var html = ``;
  if (products.length == 0 && searchMsgStatus == 0) {
    html = `<h1 class="ProductMeta__Title Heading u-h2" style="padding-top: 100px; padding-bottom: 100px; text-align: center;">This wishlist is not found or private</h1>`;
  } else if (products.length == 0 && searchMsgStatus == 1) {
    html = `<h1 class="ProductMeta__Title Heading u-h2" style="padding-top: 100px; padding-bottom: 100px; text-align: center;">No wish list found for the provided mobile number. Let us help you find the perfect gift for your loved ones. Happy shopping!</h1>`;
  } else {
    html = `<div class="ProductList ProductList--grid ProductList--removeMargin Grid" data-mobile-count="2" data-desktop-count="4">`;

    console.log("DRAW WISHLIST CALL");
    for (var i = 0; i < products.length; i++) {
      const settings = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      const fetchResponse = await fetch(`${products[i].prod_url}.js`, settings);
      const data = await fetchResponse.json();
      products[i].price = data.price / 100;
      // products[i].price = (data.price / 100);
      products[i].media.img_url = data.featured_image;
      // debugger;
      html += `<div class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--lap-and-up"`;
      if (products[i].approve_status) html += ` style="opacity: 40%">`;
      else html += `>`;
      if (products[i].approve_status)
        html += `<div style="font-size: 18px; font-weight: bold; text-align: center; margin-top: 10px;">Gifted</div>`;
      html +=
        `<div class="ProductItem" style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;">
                    <div data-log="106" class="ProductItem__Wrapper">
                      <a href="` +
        products[i].prod_url +
        `?variant=` +
        products[i].variant_id +
        `" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">`;
      if (!document.location.href.includes("wishlist-search")) {
        html +=
          `<button class="close-btn" onClick="removeItem(event, '` +
          products[i].prod_url +
          `', '` +
          products[i].variant_id +
          `')" style="padding-left: 10px; padding-right: 10px; border-radius: 20px; z-index: 1; position: absolute; right: 0">✖</button>`;
      }

      html +=
        `<div class="AspectRatio AspectRatio--withFallback" style="max-width: 1000px; padding-bottom: 100.0%; --aspect-ratio: 1.0">
                          <img class="ProductItem__Image ProductItem__Image--alternate Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="Bold Pavé Star Charm" data-media-id="` +
        products[i].media.id +
        `" data-srcset="` +
        products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
        ` 600w" sizes="218px" srcset="` +
        products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
        ` 600w">
                          <img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,400,600,700,800,900,1000]" data-sizes="auto" alt="` +
        products[i].media.alt_text +
        `" data-srcset="` +
        products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
        ` 600w" sizes="218px" srcset="` +
        products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
        `">
                          <span class="Image__Loader"></span>
                          <noscript>
                            <img class="ProductItem__Image ProductItem__Image--alternate" src="` +
        products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
        `" alt="` +
        products[i].media.alt_text +
        `">
                            <img class="ProductItem__Image" src="` +
        products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
        `" alt="` +
        products[i].media.alt_text +
        `">
                          </noscript>
                        </div>
                      </a>
                      <div class="ProductItem__Info ProductItem__Info--left">
                        <h2 class="ProductItem__Title Heading">
                          <a href="` +
        products[i].prod_url +
        `?variant=` +
        products[i].variant_id +
        `">` +
        products[i].title +
        `</a>
                        </h2>`;
      // debugger;
      if (variants[i]?.title != "Default Title") {
        html +=
          `<h3 class="ProductItem__Title Heading">Size: ` +
          variants[i]?.title +
          `</h3>`;
      }
      html +=
        `<div class="ProductItem__PriceList Heading">
                          <span class="ProductItem__Price Price Text--subdued">` +
        products[i].price +
        ` JD</span>
                        </div>
                      </div>  
                    </div>
                    <div class="wishlist-button-group">`;

      // if (!document.location.href.includes("wishlist-search")) {
      //   html += `<button type="button" id="wishlist-btn-remove-` + products[i].prod_url + `" onClick="removeItem('` + products[i].prod_url + `')" class="ProductForm__AddToCart Button Button--secondary Button-full" style="margin-top: 15px; margin-bottom: 10px; width: 100%;">
      //               Remove from Wishlist
      //             </button>`;
      // }

      html +=
        `<form method="post" action="/cart/add" id="product_form_` +
        products[i].id +
        `" accept-charset="UTF-8" class="ProductForm" enctype="multipart/form-data">
                          <input type="hidden" name="form_type" value="product">
                          <input type="hidden" name="utf8" value="✓">
                        
                          <!-- Include the variant ID -->
                          <input type="hidden" name="id" value="` +
        products[i].variant_id +
        `">
                        
                          <!-- Set the quantity to 1, or allow the customer to choose a quantity -->
                          <input type="hidden" name="quantity" value="1" min="1" class="ProductForm__Quantity">`;
      if (variants[i].inventory_quantity > 0) {
        html +=
          `<button type="submit" class="ProductForm__AddToCart Button Button--primary Button--full" onclick="addToCart(event, ` +
          products[i].id +
          `, '` +
          products[i].variant_id +
          `')">
                                      <span>ADD TO CART</span>
                                    </button>`;
      } else {
        html += `<button type="submit" class="ProductForm__AddToCart Button Button--secondary Button--full" disabled="disabled">
                                      <span>SOLD OUT</span>
                                    </button>`;
      }
      html += `</form>
                     </div>
                  </div>
                </div>`;
    }

    html += `</div>`;
  }

  if (document.getElementById("wishlist-item"))
    document.getElementById("wishlist-item").innerHTML = html;
  if (document.getElementById("wishlist-search"))
    document.getElementById("wishlist-search").innerHTML = html;

  const gridElements = document.getElementsByClassName("Grid__Cell");
  const buttonGroups = document.getElementsByClassName("wishlist-button-group");
  var maxHeight = 0;

  for (var i = 0; i < gridElements.length; i++) {
    if (gridElements[i].offsetHeight > maxHeight)
      maxHeight = gridElements[i].offsetHeight;
  }

  for (var i = 0; i < gridElements.length; i++) {
    gridElements[i].style.height = maxHeight + "px";
  }
}

var giftBtnStatus = 0;

async function drawWishListsGift(phone_number) {
  // var html = `<button onclick="goBack(0)"><img style="width: 50px; height: 50px; position: absolute; margin-top: 20px; margin-left: 20px;" src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC5klEQVR4nO2ay2pUQRCGvxHR6MKloIgbjePCe0IUdOfCGBJ8AHElmryBSzeujAkJmszCBxDEBxDUrDRD8JqtdzGuHC9IDI5GRwp6YBjO6Dndffr0mdM//DAwM13117lUdXVBQEBAQEBA2tgNjAEV4B7wCvgM/FSUzy/Vd7PAKFAm5zgATAJLQEOT74EJYD85QQkYAaoGojtxHhhWNrzEAPAwBeHtXAD68QgbgKvAbwfimxRb00BP1uLLwKJD4e18CvRmJf4wUMtQfJOSQY65Fn8SWPFAfJPfgUFX4o8Ayx6IbueKizuhDHzxQGwnfkrzndADPPFA5P+4qDKTdVzzQFxcTtkW3w+seiAsSZ0ghZkVlBxVeLZZtVU2j1h06htwFvjgKAiSro1RteTML2BIrblFbW7SDsADG1vahiVKP6AV64DbDoKwzyQAk5acGI9Ye7vK22kHIMp2bCxZcOAWsCbi6i84EC98Z9LGahhSssfGFO+suNypE4AxQ6PS99vcIav8cRyA8zoBqBgY/ArsiVhzW0ZbaKliE2NO05h0eY9HrLcWuJ+BeOEdnQC80TAkt/aZf6y5CdgK7AL6VKBOAadVK/wCcEnV8teBmypVSuCeqcdKMkc9oV/yv8SoaQTgIu6QxK+POgbqCY3ccNyyTuLbDx0D9aIHoFb0R+B10V+CcxoB6Ko0WCl6ITTaRaXwOd0WeKPImyHU+Xzet8NvMcBEFzRELhe9JbYXQ8znuCkqadcYwzlui1s5MS45fGF51RJvRV/OjsbE14NYxrQHwuJS6gzrWA889kBcZsfjqOEDF7lbl7LP2IGD4ahlD8RGjcgcxREG1WBSwxOKLydwjAHVafFhTM7ZlY96J2Q5N/TIxTMfZ3hqynGdsKpSnWQmb3AopSnxqArPepFjE0PKyTQ2Ns6mQW1AJjOuqPN5k2bGuI0tbdboVX25GeAu8KKlvV1Xn5+r7u2M+q12GysgICAgIIBY+AsR/GFgu23zgwAAAABJRU5ErkJggg=='/></button>`
  var html = `<div class="Gift-Container" style="position: absolute;">
                  <button onclick="goBack(0)" style="position: absolute; font-family: Pan Display Bold; font-size: 20px; position: absolute; background-color: white; padding: 5px 20px; font-weight: bold; top: 20px; left: 30px; border-radius: 20px;">Back</button>
                  <button onclick="toggleFullScreen()"><img style="width: 20px; height: 20px; position: absolute; top: 30px; right: 30px;" src='data:image/png;base64,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'/></button>
              </div>`;
  if (
    products.length > 0 &&
    products[0].user_info &&
    products[0].user_info.first_name &&
    products[0].user_info.first_name
  ) {
    html +=
      `<div class="font_4_4" style="font-family: Pan Display Bold; padding-top: 15.7vh; padding-left: 26%; letter-spacing: 0.6vh;">` +
      products[0].user_info.first_name.substring(0, 1).toUpperCase() +
      products[0].user_info.first_name.substring(1) +
      `'s</div>`;
  } else {
    html += `<div class="font_4_4" style="font-family: Pan Display Bold; padding-top: 15.7vh; padding-left: 26%; letter-spacing: 0.6vh;"></div>`;
  }
  html += `<div class="font_5_1 font-brightwall" style="padding-top: 0.4vh; padding-left: 45%; letter-spacing: 0.5vh; padding-bottom: 1vh;">Picks</div>
              <div class="ProductList ProductList--grid ProductList--removeMargin Grid" data-mobile-count="2" data-desktop-count="4" style="height: 45vh; overflow: auto; padding-right: 55px;">`;

  if (products.length == 0 && searchMsgStatus == 0) {
    html += `<div style="font-size: 32px; font-family: Pan Display Bold; text-align: center; margin-top: 15vh; padding-left: 9vw;">No wishlist available</div>`;
  } else if (products.length == 0 && searchMsgStatus == 1) {
    html += `<div style="font-size: 22px; font-family: Pan Display Bold; text-align: center; margin-top: 15vh; padding-left: 6vw;">No wish list found for the provided mobile number. Enjoy browsing our selection and finding the perfect gift for your loved ones. Happy shopping!</div>`;
  }

  for (var i = 0; i < products.length; i++) {
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const fetchResponse = await fetch(`${products[i].prod_url}.js`, settings);
    const data = await fetchResponse.json();
    products[i].price = data.price / 100;
    // products[i].price = (data.price / 100);
    products[i].media.img_url = data.featured_image;
    if (products[i].gift_status) giftBtnStatus += 1;
    html += `<div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/2--lap-and-up" style="margin-bottom: 20px; padding-left: 80px;`;
    if (products[i].approve_status) html += ` opacity: 70%">`;
    else html += `">`;
    if (products[i].approve_status)
      html += `<div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px;">Gifted</div>`;
    html +=
      `<div class="ProductItem ">
                  <div data-log="214" class="ProductItem__Wrapper" style="display: flex; align-items: flex-start;">
                    <div style="display: flex; align-items: center;">
                      <input type='checkbox' id="gift-checkbox-` +
      i +
      `" style="margin-right: 25px; width: 20px; height: 20px; border-width: 1px; border-color: black; accent-color: #f9eff0" onclick="handleClickGift(this, '` +
      products[i].variant_sku +
      `', '` +
      phone_number +
      `')"`;
    if (products[i].gift_status) html += ` checked `;
    if (products[i].approve_status)
      html += ` disabled><div class="AspectRatio AspectRatio--withFallback" style="max-width: 1000px; padding-bottom: 100.0%; --aspect-ratio: 1.0; width: 60px; height: 60px; margin-right: 10px;">`;
    else
      html +=
        `><div class="AspectRatio AspectRatio--withFallback" style="max-width: 1000px; padding-bottom: 100.0%; --aspect-ratio: 1.0; width: 60px; height: 60px; margin-right: 10px;" onclick="handleClickGiftByTitle(` +
        i +
        `, '` +
        products[i].variant_sku +
        `', '` +
        phone_number +
        `')">`;
    html +=
      `<img class="ProductItem__Image ProductItem__Image--alternate Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,300,400,600,800,900,1000]" data-sizes="auto" alt="Bold Pavé Star Charm" data-media-id="` +
      products[i].media.id +
      `" data-srcset="` +
      products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
      ` 600w" sizes="218px" srcset="` +
      products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
      ` 600w">
                        <img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,400,600,700,800,900,1000]" data-sizes="auto" alt="` +
      products[i].media.alt_text +
      `" data-srcset="` +
      products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
      ` 600w" sizes="218px" srcset="` +
      products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
      `">
                        <span class="Image__Loader"></span>
                        <noscript>
                          <img class="ProductItem__Image ProductItem__Image--alternate" src="` +
      products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
      `" alt="` +
      products[i].media.alt_text +
      `">
                          <img class="ProductItem__Image" src="` +
      products[i].media.img_url.replace(/\\n/g, "").replace(/\s/g, "") +
      `" alt="` +
      products[i].media.alt_text +
      `">
                        </noscript>
                      </div>
                    </div>`;
    if (products[i].approve_status)
      html += `<div class="ProductItem__Info ProductItem__Info--left" style="margin-top: 0px;">`;
    else
      html +=
        `<div class="ProductItem__Info ProductItem__Info--left" style="margin-top: 0px;" onclick="handleClickGiftByTitle(` +
        i +
        `, '` +
        products[i].variant_sku +
        `', '` +
        phone_number +
        `')">`;
    html +=
      `<h2 class="ProductItem__Title Heading">
                        ` +
      products[i].title +
      `
                      </h2>`;
    if (variants[i].title != "Default Title") {
      html +=
        `<h3 class="ProductItem__Title Heading">Size: ` +
        variants[i].title +
        `</h3>`;
    }
    html +=
      `
                      <div class="ProductItem__PriceList  Heading">
                        <span class="ProductItem__Price Price Text--subdued">` +
      products[i].price +
      ` JD</span>
                      </div>
                    </div>  
                  </div>
                </div>
              </div>`;
  }

  html += `</div>
            <div class="Gift-Container" style="position: absolute; bottom: 0;">
                <img style="width: 100px; height: 100px; float: right; margin-right: 50px; margin-bottom: 50px;" src='https://cdn.shopify.com/s/files/1/0099/8912/8258/files/Pandora_Register_150x.png?v=1706515432'/>
            </div>
            <button id="gift-next-btn" onclick="nextWishlist()" class="font_2_3" style="font-family: Pan Display Bold; position: absolute; width: 12%; top: 80%; left: 44%; background-color: lavender; padding: 7px; font-weight: bold; border-radius: 15px;" disabled>NEXT</button>`;

  document.getElementById("wishlist-gift-item-2").innerHTML = html;
  if (giftBtnStatus) {
    document.getElementById("gift-next-btn").disabled = false;
    document.getElementById("gift-next-btn").style.backgroundColor = "white";
  }
}

const registerBtns = document.getElementsByClassName("Form__Submit");
const registerBtn_new = registerBtns[0];

if (registerBtn_new) {
  registerBtn_new.addEventListener("click", async () => {
    const emailElements = document.getElementsByName("customer[email]");
    const email = emailElements[0].value;
    const phoneElements = document.getElementsByName("customer[phone]");
    console.log(phoneElements);
    const phone_number = phoneElements[0].value;
    const firstNameElements = document.getElementsByName(
      "customer[first_name]"
    );
    const first_name = firstNameElements[0].value;
    const lastNameElements = document.getElementsByName("customer[last_name]");
    const last_name = lastNameElements[0].value;
    if (
      email.replace(/\s/g, "") != "" &&
      phone_number.replace(/\s/g, "") != "" &&
      first_name.replace(/\s/g, "") != "" &&
      last_name.replace(/\s/g, "") != ""
    ) {
      const data = {
        status: 0,
        email: email,
        phone_number: phone_number,
        first_name: first_name,
        last_name: last_name,
      };
      const response = await fetch(
        "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/register",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      res = await response.json();

      // if (res.status == 'ok') setPopup(3);
    }
  });
}

const registerBtn_update = registerBtns[1];

if (registerBtn_update) {
  registerBtn_update.addEventListener("click", async () => {
    console.log("register phone");
    const email = document.getElementById("wishlist-item-email").textContent;
    const phoneElements = document.getElementsByName("address[phone]");
    const phone_number = phoneElements[0].value || phoneElements[1].value;
    const firstNameElements = document.getElementsByName("address[first_name]");
    const first_name = firstNameElements[0].value || firstNameElements[1].value;
    const lastNameElements = document.getElementsByName("address[last_name]");
    const last_name = lastNameElements[0].value || lastNameElements[1].value;
    console.log(email);
    if (
      email.replace(/\s/g, "") != "" &&
      phone_number.replace(/\s/g, "") != "" &&
      first_name.replace(/\s/g, "") != "" &&
      last_name.replace(/\s/g, "") != ""
    ) {
      console.log(phone_number);
      const data = {
        status: 1,
        email: email,
        phone_number: phone_number,
        first_name: first_name,
        last_name: last_name,
      };
      const response = await fetch(
        "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/register",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      res = await response.json();
    }
  });
}

async function updateCustomerAddress() {
  console.log("updateCustomerAddress");
  if (document.getElementById("wishlist-customer-id").textContent != "") {
    const data = {
      customer_id: document.getElementById("wishlist-customer-id").textContent,
      email: document.getElementById("wishlist-customer-email").textContent,
      phone: document.getElementById("wishlist-item-phone-num").textContent,
    };
    const response = await fetch(
      "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/updateCustomerAddress",
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(data),
      }
    );

    const res = await response.json();
  }
}

const searchWishlistBtn = document.getElementById("wishlist-search-btn");

if (searchWishlistBtn) {
  searchWishlistBtn.addEventListener("click", async () => {
    if (document.getElementById("wishlist-phone-number")) {
      let phone_number = document.getElementById("wishlist-phone-number").value;

      // if (phone_number.charAt(0) != "+" && phone_number.charAt(0) != "0") {
      //   phone_number = "0" + phone_number;
      // }
      const data = {
        phone_number: phone_number,
      };
      console.log(data);

      const response = await fetch(
        "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/getWishlistsByPhone",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(data),
        }
      );

      const res = await response.json();
      products = res.wishlists;
      variants = res.variants;

      if (document.location.href.includes("wishlist-search")) {
        console.log(res.status);
        if (res.status == "no user") {
          products = [];
          searchMsgStatus = 1;
          // setPopup(2);
        } else {
          searchMsgStatus = 0;
        }
        await drawWishLists();
      }

      if (document.location.href.includes("wishlist-gift")) {
        if (res.status == "no user" || res.status == "empty phone") {
          products = [];
          searchMsgStatus = 1;
        } else {
          searchMsgStatus = 0;
        }
        document.getElementById("wishlist-gift-item-1").style.display = "none";
        document.getElementById("wishlist-gift-item-2").style.display = "block";
        await drawWishListsGift(phone_number);
      }
    }
  });
}

function nextWishlist() {
  document.getElementById("wishlist-gift-item-2").style.display = "none";
  document.getElementById("wishlist-gift-item-3").style.display = "block";
}

const wishlistBtnAdd = document.getElementById("wishlist-btn-add");

if (wishlistBtnAdd) {
  wishlistBtnAdd.addEventListener("click", async () => {
    // if (document.getElementById("wishlist-item-email").textContent == '' && document.getElementById("wishlist-item-phone-num").textContent == '') {
    //   setPopup(0);
    // }
    const email = document.getElementById("wishlist-item-email").textContent;
    const phoneNum = document.getElementById(
      "wishlist-item-phone-num"
    ).textContent;

    // debugger;
    if (email === "" && phoneNum === "") {
      setPopup(0); // Show popup status(0) if email and phone number are not added
    } else {
      if (phoneNum === "") {
        return;
      }
      console.log("Else call");
      // debugger;
      const url = new URL(window.location.href);
      const variant_id = url.searchParams.get("variant");
      const phoneElementss = document.getElementsByName("address[phone]");

      // const phone_number = phoneElementss[0].value || phoneElementss[1].value,
      const data = {
        id: document.getElementById("wishlist-item-id").textContent,
        variant_id: variant_id
          ? variant_id
          : document.getElementById("wishlist-item-variant-id").textContent,
        // variant_sku: document.getElementById("wishlist-item-variant-sku").textContent,
        email: document.getElementById("wishlist-item-email").textContent,
        phone: document.getElementById("wishlist-item-phone-num").textContent,
        prod_url: document.getElementById("wishlist-item-prod-url").textContent,
        title: document.getElementById("wishlist-item-title").textContent,

        price:
          Number(document.getElementById("wishlist-item-price").textContent) /
          100,
        media: {
          img_url:
            "//pandora-eshop.jo/cdn/shop/" +
            document
              .getElementById("wishlist-item-img-url")
              .textContent.replace(/\\n/g, "")
              .replace(/\s/g, ""),
          alt_text: document.getElementById("wishlist-item-alt").textContent,
          id: Number(
            document.getElementById("wishlist-item-media-id").textContent
          ),
        },
      };

      console.log(data);
      const customerData = {
        email: document.getElementById("wishlist-item-email").textContent,
        phone_number: document.getElementById("wishlist-item-phone-num")
          .textContent,
        first_name: document.getElementById("wishlist-item-first-name")
          .textContent,
        last_name: document.getElementById("wishlist-item-last-name")
          .textContent,
      };

      var status = true;
      await fetch(
        "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/register",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(customerData),
        }
      ).then(async (response) => {
        const res = await response.json();
        const users = res.user;
        console.log(res);
        // console.log(users);

        // if (users.length == 0) {
        //   status = true;
        // } else {
        //   status = users[0].type == 1 ? true : false;
        // }
      });

      //       setPopup(2);
      //       var delayInMilliseconds = 60000; //1 min

      //     setTimeout(function() {

      // }, delayInMilliseconds);
      //your code to be executed after 1 second - await
      debugger;
      await fetch(
        "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/addItem",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(data),
        }
      ).then(async (response) => {
        const res = await response.json();
        console.log(res);

        const data = {
          email: document.getElementById("wishlist-item-email").textContent,
          phone: document.getElementById("wishlist-item-phone-num").textContent,
        };

        const response_1 = await fetch(
          "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/getWishlists",
          {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(data),
          }
        );

        const res_1 = await response_1.json();
        products = res_1.wishlists;
        variants = res_1.variants;

        if (phoneNum !== "") {
          // Only show the popup if the phone number is present
          if (res.status == "ok") {
            if (products.length == 1) {
              setPopup(1); // Show popup status(1) if the customer has added their number
              document.getElementById("user-type").checked = status;
            } else {
              setPopup(5);
            }
          } else if (res.status == "already added") {
            setPopup(4);
          }
        }

        console.log(status);
        // console.log(document.getElementById("wishlist-item-phone-num"));
      });
    }
  });
}

async function getItem() {
  if (
    document.getElementById("wishlist-item-email").textContent != "" &&
    document.getElementById("wishlist-item-phone-num").textContent != ""
  ) {
    const data = {
      email: document.getElementById("wishlist-item-email").textContent,
      phone: document.getElementById("wishlist-item-phone-num").textContent,
    };
    const response = await fetch(
      "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/getWishlists",
      {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(data),
      }
    );

    const res = await response.json();
    products = res.wishlists;
    variants = res.variants;
  }
  await drawWishLists();
}

async function removeItem(event, prod_url, variant_id) {
  event.preventDefault();
  event.stopPropagation();

  const data = {
    email: document.getElementById("wishlist-item-email").textContent,
    phone_number: document.getElementById("wishlist-item-phone-num")
      .textContent,
    prod_url: prod_url,
    variant_id: variant_id,
  };
  await fetch(
    "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/removeItem",
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    }
  ).then(async (response) => {
    const res = await response.json();
    products = res.wishlists;
    variants = res.variants;

    await drawWishLists();
  });
}

const popup = document.getElementById("popup");
const closeBtn = document.getElementById("closeBtn");

function setPopup(status) {
  var html = ``;
  if (status == 0) {
    html = `<img style="width: 50px; height: 50px; margin-top: 30px; margin-bottom: 30px;" src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAACCCAMAAAC93eDPAAAAaVBMVEX///8AAADz8/Pq6ur6+vrh4eH39/fk5OTw8PDb29tubm5bW1tOTk7Y2Njn5+cgICCFhYVTU1NISEh0dHQtLS1lZWXBwcGOjo6enp7Ozs4nJyd+fn4bGxs/Pz8PDw+2trY0NDSpqamWlpZJpol+AAAEQ0lEQVR4nO1b2bKiMBC9AgaI7Moqi/j/HzkmDS53BOnQcWqqOI+ahEN679afnw0bNmzYsGHDBq1ghuMY7F893XL7iMdJ0yQxj3rX+vrzO97uXsG7b7Jwz7u3OPpfIhAcf1/A01XY32BQvDwzvFzClw8K7QSCy+ON+9KBD52yP94/Pmm+iG58UJr9MkWWpeN3nU4GoxDSt3rnc/3CGBi05dSCsoYVuWYG57k1Eay56mHQLZJ0Bqt6HQx8ODv7tK6EdTq81GkZg5FDSO+uo+X2ln1WGRXsMVp21SIK6XeSpasTsfpAywDk6y5dvl+qNwgckNLNxXqPkoErTqz3yzfYIbU2SL94xOyIqH1kjdIEAdAGOgamlCzK11hSexCi+4BOIfoVtJFCZquTEfo9fFIPCZeK3SX2xFRVjiHyxRq7S4S10CGiYCr5GenSTUoKKK8gEJFTiLC7ckqrtJUy0hztzmZgKtkX6S1ICil215lSFxxRxjbYXQklBdaouCbB+2IQUfjhCi9kSOmRpdFXhZCjEtpmUCr4pog2e7TEcS3K3zuV2EOmCoO/R7UNMur8VR6YYHTLQ5P+AHZCSlZyJgvVEtLbXpavT5Qi2yzMCpWUy8SxJu57FZhKFVUDLwaTzb5mkXQdqYsVoUUCoGmwKF5yDUWtBPQ4FlTs0H8k73AIHOAePtwvgzuItbTlgwYOn82EAiB6oSvlXiBzyPmY2Q1Nek0Mbq8IXbddMmGcfgzfh9oY3DgMz2hT/y9ZW/44qPE0Mrgp273pfyjsZxZ2cRi/4eQO4Rfu44DbffO877qs63NePT7VOgoAGNFuBmfS6DiJfTJFoKGqnuZhFOnkeKxNC/234B+nHn/XRmQ7Bokyfnla6MWHG2LvdUiX6CNh88djqviauTZjN8O0GAvcrIhPj29TTZ7haUCZl29EbpT5Y4WOyZB9f0k+kwmUd1WpyY1j9Ejt+UNGGESjvRCPp8Y5ebrg3dxRZdDtqTkMhlAtVPVyjKhkeYsJuQomFxuc+CWgYRB4oAWofDSDuW1CUkswiAgt8rAAgmdDEblBDzz0UQwSiMUjtWmALaQK/ewhl+ZrGfRwB0rxz4B7WPlTAqgOa8WevgXGuW5KBmcoq7UpPSV6jvAMmPyuqA6hEl3ReIPaZVWnAl5CPWRJla7WeVnZFEA3sEfAoHplCuSvkmVMYtbnFQ5KXkK7OvPY1+rXwFfrIkCmc7HKTkcKkWCgYCr7Fvy0fgpSGxTyWSsmMAeANIoGb9syOlQUDAbfgNfrYqVnJTgrJZPDYN7oH/g4zdoQ9wxRc56wqayvRHwKXOVKM4J85wGZe2Grq3xlovCKElmGSBxI4sOIvVAG7Lz3pKJAk5DKjXUyohBJyH5vz0RBhvwFpCEiLGE3XcoVeakNTaAekSsIYh/XnPB/D+wYeuhygpHpIsD8Z3/k2LBhw4YNGzb8//gDhw8q3iOHF+wAAAAASUVORK5CYII='/>
            <p>
                You should log in.
            </p>
            <a href="https://pandora-eshop.jo/account/login" onClick="closePopup()" class="view-btn">Log in</a>`;
  } else if (status == 1) {
    html = `<img style="width: 40px; height: 35px; margin-top: 30px; margin-bottom: 30px;" src='data:image/png;base64,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'/>
            <p>
                Product added to Wishlist.
            </p>
            <input type="checkbox" id="user-type" style="margin-left: 10px; margin-right: 10px;" onclick='handleClick(this);'>Share your wishlist with gift seekers!</input>
            <button class="close-btn" onClick="closePopup()" style="margin-right: 10px;"><span style="font-weight: bold; margin-right: 5px;">✖</span> Close</button>
            <a href="https://pandora-eshop.jo/pages/wishlist" onClick="closePopup()" class="view-btn">View Wishlist</a>`;
  } else if (status == 2) {
    html = `<p style="margin-top: 25px;">
                You should register your phone & other details. Please Edit Your Details here!
            </p>
            <a href="https://pandora-eshop.jo/account/addresses" onClick="closePopup()" class="view-btn">Phone register</a>`;
  } else if (status == 3) {
    html = `<p style="margin-top: 25px;">
                Phone number is registered successfully.
            </p>
            <button class="close-btn" onClick="closePopup()">Close</button>`;
  } else if (status == 4) {
    html = `<img style="width: 40px; height: 35px; margin-top: 30px; margin-bottom: 30px;" src='data:image/png;base64,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'/>
            <p>
                Product has already been added.
            </p>
            <button class="close-btn" onClick="closePopup()" style="margin-right: 10px;"><span style="font-weight: bold; margin-right: 5px;">✖</span> Close</button>
            <a href="https://pandora-eshop.jo/pages/wishlist" onClick="closePopup()" class="view-btn">View Wishlist</a>`;
  } else if (status == 5) {
    html = `<img style="width: 40px; height: 35px; margin-top: 30px; margin-bottom: 30px;" src='data:image/png;base64,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'/>
            <p>
                Product added to Wishlist.
            </p>
            <button class="close-btn" onClick="closePopup()" style="margin-right: 10px;"><span style="font-weight: bold; margin-right: 5px;">✖</span> Close</button>
            <a href="https://pandora-eshop.jo/pages/wishlist" onClick="closePopup()" class="view-btn">View Wishlist</a>`;
  } else if (status == 6) {
    html = `<p>
                Help Your Loved Ones Make Your Wishes Come True!<br>
                Create your personalized Wish List  and make gift-giving a joyous experience for your friends and family.
            </p>
            <button class="close-btn" onClick="closePopup()">Close</button>`;
  }

  document.getElementById("popup-content").innerHTML = html;
  popup.style.display = "block";
}

function closePopup() {
  popup.style.display = "none";
}

function addToCart(event, productId, variantId) {
  event.preventDefault();

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .then(() => {
      var timestamp = new Date().getTime();

      return fetch("/cart?view=drawer&timestamp=" + timestamp); // Adjust this URL based on how your theme provides the cart drawer HTML
    })
    .then((response) => response.text())
    .then((newHtml) => {
      console.log(newHtml);
      openCartDrawer();

      var parser = new DOMParser();
      var doc = parser.parseFromString(newHtml, "text/html");

      var newSidebarCart = doc.getElementById("sidebar-cart");
      newSidebarCart.setAttribute("aria-hidden", "false");
      newSidebarCart.setAttribute("tabindex", "-1");

      var closeBtn = doc.querySelector('button[data-drawer-id="sidebar-cart"]');
      console.log(closeBtn);
      closeBtn.onclick = closeCart;

      var oldSidebarCart = document.getElementById("sidebar-cart");
      if (oldSidebarCart && newSidebarCart) {
        oldSidebarCart.replaceWith(newSidebarCart);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function openCartDrawer() {
  var cartIcon = document.querySelector('a[data-drawer-id="sidebar-cart"]'); // Use the correct selector for your theme
  if (cartIcon) {
    cartIcon.click();
  }
}

function closeCart() {
  document.getElementById("sidebar-cart").setAttribute("aria-hidden", "true");
  console.log("click cart");
}

async function handleClick(ele) {
  console.log("Clicked, new value = `" + ele.checked + "`");
  const data = {
    type: ele.checked == true ? 1 : 0,
    email: document.getElementById("wishlist-item-email").textContent,
  };
  const response = await fetch(
    "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/setUserType",
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    }
  );
}

async function handleClickGift(ele, sku, phone_number) {
  console.log(
    "Clicked, new value = `" + ele.checked + "` " + sku + ", " + phone_number
  );
  if (ele.checked) {
    giftBtnStatus += 1;
  } else {
    giftBtnStatus -= 1;
  }

  if (giftBtnStatus) {
    document.getElementById("gift-next-btn").disabled = false;
    document.getElementById("gift-next-btn").style.backgroundColor = "white";
  } else {
    document.getElementById("gift-next-btn").disabled = true;
    document.getElementById("gift-next-btn").style.backgroundColor = "lavender";
  }
  const data = {
    gift_status: ele.checked == true ? 1 : 0,
    phone_number: phone_number,
    variant_sku: sku,
  };
  const response = await fetch(
    "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/setGiftType",
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    }
  );
}

async function handleClickGiftByTitle(i, sku, phone_number) {
  console.log("Clicked, new value = `" + i + "` " + sku + ", " + phone_number);
  const status = document.getElementById("gift-checkbox-" + i);
  console.log(status.checked);
  if (status.checked) {
    giftBtnStatus += 1;
    document.getElementById("gift-checkbox-" + i).checked = false;
  } else {
    giftBtnStatus -= 1;
    document.getElementById("gift-checkbox-" + i).checked = true;
  }

  if (giftBtnStatus) {
    document.getElementById("gift-next-btn").disabled = false;
    document.getElementById("gift-next-btn").style.backgroundColor = "white";
  } else {
    document.getElementById("gift-next-btn").disabled = true;
    document.getElementById("gift-next-btn").style.backgroundColor = "lavender";
  }
  const data = {
    gift_status: status.checked == true ? 1 : 0,
    phone_number: phone_number,
    variant_sku: sku,
  };
  const response = await fetch(
    "https://wishlist-gift-app-cold-field-9745.fly.dev/pandora/setGiftType",
    {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    }
  );
}

function shareWishlistViaWhatsApp() {
  var urlToShare =
    "https://pandora-eshop.jo/pages/wishlist?k=" +
    document.getElementById("wishlist-item-email").textContent;
  let message = "Checkout my wishlist\n" + urlToShare;
  // for (var i = 0; i < products.length; i++) {
  //   message += i + 1 + ': ' + products[i].title + '\n';
  //   if (variants[i].title != "Default Title") {
  //     message += 'Size: ' + variants[i].title + '\n';
  //   }
  //   message += products[i].price + ' JD\n';

  //   var urlToShare = 'https://pandora-eshop.jo/' + products[i].prod_url + `?variant=` + products[i].variant_id;

  //   message += urlToShare + '\n\n';
  // }

  let urlEncodedMessage = encodeURIComponent(message);

  console.log(message);

  let whatsappUrl = `https://wa.me/?text=${urlEncodedMessage}`;

  window.open(whatsappUrl, "_blank");
}

function goBack(status) {
  console.log("ssss" + status);
  if (status == 0 || status == 2) {
    document.getElementById("wishlist-gift-item-1").style.display = "block";
    document.getElementById("wishlist-gift-item-2").style.display = "none";
    document.getElementById("wishlist-gift-item-3").style.display = "none";
  } else if (status == 1) {
    document.getElementById("wishlist-gift-item-1").style.display = "none";
    document.getElementById("wishlist-gift-item-2").style.display = "block";
    document.getElementById("wishlist-gift-item-3").style.display = "none";
  }
}

function toggleFullScreen() {
  if (
    !document.fullscreenElement && // alternative standard method
    !document.mozFullScreenElement &&
    !document.webkitFullscreenElement &&
    !document.msFullscreenElement
  ) {
    // current working methods
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
      document.documentElement.msRequestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen(
        Element.ALLOW_KEYBOARD_INPUT
      );
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }
}
